import { Injectable } from '@angular/core';
import { asyncForEach } from "../../helpers/asyncForEach";
import { to64decode } from "../../helpers/base64";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  async localStorageToJsonAsync(onlyLanguage: boolean = false) {
    let keys = Object.keys(localStorage);
    let includes = ['token'];
    let json: any = {};

    await asyncForEach(keys, async (key: string) => {
      let value = localStorage.getItem(key);
      if (value === null || value === undefined || value === '') {
        return;
      }

      let decodedValue = decodeURIComponent(value);

      if (key !== 'language' && onlyLanguage) {
        return;
      }

      if (key === 'user') {
        key = 'me';
      }

      if (includes.includes(key)) {
        json[key] = decodedValue;
      } else {
        json[key] = to64decode(decodedValue);
      }
    });

    return json;
  }
} 